import LogoSmall from "../../Assets/IMG/LogoSmall.png";

export const AppName = "Emril Admin";

export const Colors = {
  BlackPrimary: "var(--black-primary)",
  BluePrimary: "var(--blue-primary)",
  BlueSecondary: "var(--blue-secondary)",

  PurplePrimary: "var(--purple-primary)",
  PurpleSecondary: "var(--purple-secondary)",
  PurpleTertiary: "var(--purple-tertiary)",

  GreenLight: "var(--green-light)",
  GreenPrimary: "var(--green-primary)",
  GreenSecondary: "var(--green-secondary)",

  GrayPrimary: "var(--gray-primary)",

  GrayTertiary: "var(--gray-tertiary)",
  GraySecondary: "var(--gray-secondary)",
  White: "var(--white-primary)",
  WhiteBlueTransparent: "var(--white-blue-transparent)",
  RedPrimary: "var(--red-primary)",
  OrangePrimary: "var(--orange-primary)",
  OrangeSecondary: "var(--orange-secondary)",
  Transparent: "var(--transparent)",
};

export { LogoSmall };

export const HttpSuccessCodes: number[] = [200, 201];
export const HttpErrorCodes: number[] = [400, 401, 402, 403, 404, 409, 500];
export const HttpSuccessCodesObj = {
  Success: 200,
  Created: 201,
  Accepted: 202,
  NoContent: 204,
};
export const HttpErrorCodesObj = {
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  Conflict: 409,
  InternalServerError: 500,
  UnprocessableEntity: 422,
};

export const ValidOtpLength = 6;
export const OtpWaitTime = 5;
export const ValidPasswordLength = 8;

export const AdminRolesList = [
  { label: "Super Admin", value: "superadmin" },
  { label: "Admin", value: "admin" },
];

export const YesOrNoList = [
  { label: "Yes", value: "yes", alternativeLabel: "Active" },
  { label: "No", value: "no", alternativeLabel: "Inactive" },
];

export const AppDomain = "emrilacademy.com";

export const ValidIDLength = 32;

export const TrueFalseList: ("true" | "false")[] = ["true", "false"];
